<template>
    <div>
        <template v-if="crud_cities == true">
            <div class="page-top mb-1 mb-3">
                <h1> Add City</h1>
            </div>
            <div class="global-main">
                <form id="cityForm" @submit.prevent="addCityData">
                    <div class="tab-content-inner">
                        <div class="form-group">
                            <label> Name </label>
                            <input v-model="form.name" type="text" name="name" class="form-control" :class="{ 'is-invalid': form.errors.has('name') }">
                            <has-error :form="form" field="name"></has-error>
                        </div>
                        <div class="form-group">
                            <label> Region </label>
                            <select v-model="form.region_id" name="region_id" class="selectpicker custom-select2" :class="{ 'form-control is-invalid': form.errors.has('region_id') }" v-if="regions != null">
                                <option value="" selected>Select Region</option>
                                <option v-for="region in regions" v-bind:value="region.id" v-bind:key="region.id">
                                    {{ region.name }}
                                </option>
                            </select>
                            <has-error :form="form" field="region_id"></has-error>
                        </div>
                        <div class="form-group">
                            <label> Risk Rating </label>
                            <select v-model="form.risk_rating_id" name="risk_rating_id" class="selectpicker custom-select2" :class="{ 'form-control is-invalid': form.errors.has('risk_rating_id') }">
                                <option value="" selected>Select Risk Rating</option>
                                <option v-for="rRating in riskRatings" v-bind:value="rRating.id" v-bind:key="rRating.id">
                                    {{ rRating.rating }}
                                </option>
                            </select>
                            <has-error :form="form" field="risk_rating_id"></has-error>
                        </div>
                    </div>
                    <div class="form-group">
                        <button :disabled="form.busy" class="btn btn-primary float-right active">Save</button>
                        <router-link to="/cities" class="btn btn-primary float-right mr-2">Cancel</router-link>
                    </div>
                </form>
            </div>
        </template>
        <template v-else-if="crud_cities === null">
            <preLoader></preLoader>
        </template>
        <template v-else-if="crud_cities === false">
            <notAllowed></notAllowed>
        </template>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                form: new Form({
                    name : '',
                    region_id : '',
                    risk_rating_id: ''
                }),
                regions: null,
                crud_cities: null,
                riskRatings: []
            }
        },
        methods: {
            addCityData() {
                this.$Progress.start();
                this.form.post('api/addCity')
                .then(res => {
                    if(res.status == 200){
                        this.$Progress.finish();
                        this.showToastBox('success','City created successfully');
                        this.$router.push('/cities');
                    }else{
                        this.$Progress.fail();
                        this.showAlertBox('error','Some error in your form data');
                    }
                })
                .catch(err => {
                    this.promptValidationErrors(err, 'Some error in your form data');
                    this.$Progress.fail();
                })
            },
            getRegionData(){
                axios.get('/api/regionData')
                .then(res => {
                    this.regions = res.data.record;
                }).then(res=>{
                    $(this.$el).find('.selectpicker').selectpicker('refresh');
                })
                .catch(err => {
                    console.log(err);
                });
            },
            getRiskRatings(){
                axios.get('/api/riskRatings')
                .then(res => {
                    this.riskRatings = res.data.data;
                }).then(res=>{
                    $(this.$el).find('.selectpicker').selectpicker('refresh');
                })
                .catch(err => {
                    console.log(err);
                });
            }
        },
        mounted() {
            this.$Progress.start();
			this.can('crud_cities').then(result => {
                this.crud_cities = result.crud_cities;
            }).then(result => {
                if(this.crud_cities == true){
                    this.getRegionData();
                    this.getRiskRatings();
                    this.$Progress.finish();
                }else{
                    this.$Progress.finish();
                }
            });
        },
    }
</script>
